import Toast from 'react-native-toast-message';

/**
 * Global Toast Utility — the single toast surface for SK-Tickets.
 *
 * Uses react-native-toast-message rendered through the premium themed host
 * (`components/Toast/Toast_Host[.web]` + `Toast_Config`), mounted once at the
 * app root (App.web.tsx / App.tsx). Every toast in the app — service-layer
 * (showSuccess/handleApiError), screen-level (useApp().toast), and direct
 * showToast calls — funnels through here, so they all render identically.
 *
 * `text1` is the bold heading; optional `text2` is the detail line.
 */

// The app uses richer tones internally (info/warn/danger); normalize them to the
// three types the toast host renders (success | error | info).
type Tone = 'success' | 'error' | 'info' | 'warn' | 'danger';
const normalizeType = (t: Tone): 'success' | 'error' | 'info' =>
  t === 'danger' ? 'error' : t === 'warn' ? 'info' : (t as 'success' | 'error' | 'info');

export const showToast = (type: Tone, text1: string, text2?: string) => {
  const kind = normalizeType(type);
  Toast.show({
    type: kind,
    text1,
    text2,
    // Success: short confirmation. Error/info: longer so multi-sentence backend
    // messages can be read fully before auto-dismiss.
    visibilityTime: kind === 'success' ? 3000 : 4000,
    autoHide: true,
    topOffset: 60,
    // Allow long backend messages (validation/conflict text) to wrap, not clip.
    ...(text2 ? ({ text2NumberOfLines: 5 } as any) : {}),
  });
};
